import { SVGProps } from 'react';

export const DocIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    aria-hidden="true"
    width="22"
    height="26"
    viewBox="0 0 22 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.49922 18.6338H5.63255C5.39324 18.6338 5.19922 18.8278 5.19922 19.0671C5.19922 19.3064 5.39324 19.5005 5.63255 19.5005H6.49922C6.73853 19.5005 6.93255 19.3064 6.93255 19.0671C6.93255 18.8278 6.73853 18.6338 6.49922 18.6338Z"
      fill="black"
    />
    <path
      d="M18.6341 18.6338H8.23411C7.99481 18.6338 7.80078 18.8278 7.80078 19.0671C7.80078 19.3064 7.99481 19.5005 8.23411 19.5005H18.6341C18.8734 19.5005 19.0674 19.3064 19.0674 19.0671C19.0674 18.8278 18.8734 18.6338 18.6341 18.6338Z"
      fill="black"
    />
    <path
      d="M6.49922 16.0322H5.63255C5.39324 16.0322 5.19922 16.2263 5.19922 16.4656C5.19922 16.7049 5.39324 16.8989 5.63255 16.8989H6.49922C6.73853 16.8989 6.93255 16.7049 6.93255 16.4656C6.93255 16.2263 6.73853 16.0322 6.49922 16.0322Z"
      fill="black"
    />
    <path
      d="M18.6341 16.0322H8.23411C7.99481 16.0322 7.80078 16.2263 7.80078 16.4656C7.80078 16.7049 7.99481 16.8989 8.23411 16.8989H18.6341C18.8734 16.8989 19.0674 16.7049 19.0674 16.4656C19.0674 16.2263 18.8734 16.0322 18.6341 16.0322Z"
      fill="black"
    />
    <path
      d="M6.49922 13.4336H5.63255C5.39324 13.4336 5.19922 13.6276 5.19922 13.8669C5.19922 14.1062 5.39324 14.3003 5.63255 14.3003H6.49922C6.73853 14.3003 6.93255 14.1062 6.93255 13.8669C6.93255 13.6276 6.73853 13.4336 6.49922 13.4336Z"
      fill="black"
    />
    <path
      d="M18.6341 13.4336H8.23411C7.99481 13.4336 7.80078 13.6276 7.80078 13.8669C7.80078 14.1062 7.99481 14.3003 8.23411 14.3003H18.6341C18.8734 14.3003 19.0674 14.1062 19.0674 13.8669C19.0674 13.6276 18.8734 13.4336 18.6341 13.4336Z"
      fill="black"
    />
    <path
      d="M6.49922 10.834H5.63255C5.39324 10.834 5.19922 11.028 5.19922 11.2673C5.19922 11.5066 5.39324 11.7007 5.63255 11.7007H6.49922C6.73853 11.7007 6.93255 11.5066 6.93255 11.2673C6.93255 11.028 6.73853 10.834 6.49922 10.834Z"
      fill="black"
    />
    <path
      d="M18.6341 10.834H8.23411C7.99481 10.834 7.80078 11.028 7.80078 11.2673C7.80078 11.5066 7.99481 11.7007 8.23411 11.7007H18.6341C18.8734 11.7007 19.0674 11.5066 19.0674 11.2673C19.0674 11.028 18.8734 10.834 18.6341 10.834Z"
      fill="black"
    />
    <path
      d="M6.49922 8.23242H5.63255C5.39324 8.23242 5.19922 8.42645 5.19922 8.66576C5.19922 8.90506 5.39324 9.09909 5.63255 9.09909H6.49922C6.73853 9.09909 6.93255 8.90506 6.93255 8.66576C6.93255 8.42645 6.73853 8.23242 6.49922 8.23242Z"
      fill="black"
    />
    <path
      d="M18.6341 8.23242H8.23411C7.99481 8.23242 7.80078 8.42645 7.80078 8.66576C7.80078 8.90506 7.99481 9.09909 8.23411 9.09909H18.6341C18.8734 9.09909 19.0674 8.90506 19.0674 8.66576C19.0674 8.42645 18.8734 8.23242 18.6341 8.23242Z"
      fill="black"
    />
    <path
      d="M21.661 6.4727C21.6589 6.43473 21.6514 6.39725 21.6389 6.36133C21.6342 6.34747 21.6307 6.33403 21.6246 6.3206C21.6036 6.27348 21.5742 6.23047 21.538 6.19363L15.4713 0.126967C15.4345 0.0907292 15.3915 0.0613708 15.3443 0.0403C15.3309 0.0342333 15.3175 0.0307667 15.304 0.026C15.2678 0.0135417 15.23 0.00595833 15.1918 0.00346667C15.1844 0.00476667 15.1762 0 15.1667 0H3.03333C2.79402 0 2.6 0.194025 2.6 0.433333V1.73333H0.433333C0.194025 1.73333 0 1.92736 0 2.16667V25.5667C0 25.806 0.194025 26 0.433333 26H18.6333C18.8726 26 19.0667 25.806 19.0667 25.5667V23.4H21.2333C21.4726 23.4 21.6667 23.206 21.6667 22.9667V6.5C21.6667 6.49047 21.6619 6.48223 21.661 6.4727ZM15.6 1.4794L20.1873 6.06667H15.6V1.4794ZM18.2 25.1333H0.866666V2.6H2.6V22.9667C2.6 23.206 2.79402 23.4 3.03333 23.4H18.2V25.1333ZM20.8 22.5333H3.46667V0.866667H14.7333V6.5C14.7333 6.73931 14.9274 6.93333 15.1667 6.93333H20.8V22.5333Z"
      fill="black"
    />
  </svg>
);
